<script setup lang="ts">
import CenterModal from "~/components/Common/Modals/CenterModal.vue";
import { useNotificationsStore } from "~/store/notifications/notifications.store";
import SvgIcon from "~/components/Common/SvgIcon.vue";
import { useUploadDocumentStore } from "~/store/upload-document/upload-document.store";
import NotificationsUploadDocuments from "~/components/Pages/notifications/notifications-document/NotificationsUploadDocuments.vue";
import NotificationsPreviewDocuments from "~/components/Pages/notifications/notifications-document/NotificationsPreviewDocuments.vue";
import type { IUploadFile } from "~/utils/interfaces/documents-interfaces";
import LoadButton from "~/components/Common/Buttons/LoadButton.vue";
import AppButton from "~/components/Common/Buttons/AppButton.vue";

const uploadDocumentStore = useUploadDocumentStore();

const { files } = storeToRefs(uploadDocumentStore);
const notificationStore = useNotificationsStore();
const { showDocumentModal, createSession } = storeToRefs(notificationStore);
const load = ref(false);
const loadDocumentsLinks = ref(false);
const emit = defineEmits(["hide", "reset", "refreshDocuments"]);

const previewDocuments = ref();

function hideModal() {
  emit("hide");
}

const uploadAndHide = async (): Promise<void> => {
  load.value = true;
  await uploadDocumentStore.uploadFiles(files.value as IUploadFile[]);
  previewDocuments.value.uploadModal = false;
  uploadDocumentStore.$reset();
  load.value = false;
  emit("refreshDocuments");
};

async function documentsLinks() {
  loadDocumentsLinks.value = true;
  await notificationStore.documentsLinks();
  showDocumentModal.value = false;
  loadDocumentsLinks.value = false;
}
</script>
<template>
  <CenterModal
    style="
      max-width: 790px;
      width: 100%;
      max-height: 788px;
      height: 100%;
      display: flex;
      flex-direction: column;
      z-index: 501;
    "
    @hide="hideModal"
  >
    <template #body>
      <div class="grid grid-rows-1">
        <div class="flex justify-end p-[8px]">
          <SvgIcon class="w-[32px] h-[32px] text-secondary-color cursor-pointer" name="close" @click="hideModal">
          </SvgIcon>
        </div>
        <header class="top_header_footer"></header>
      </div>
      <div class="flex flex-col px-[64px] pt-[50px] pb-[80px] overflow-y-auto h-full stable">
        <NotificationsUploadDocuments v-if="previewDocuments?.uploadModal"></NotificationsUploadDocuments>
        <NotificationsPreviewDocuments v-show="!previewDocuments?.uploadModal" ref="previewDocuments">
        </NotificationsPreviewDocuments>
      </div>
      <div class="divider_header_footer">
        <footer>
          <div class="flex flex-row gap-[16px]">
            <AppButton
              v-if="!previewDocuments?.uploadModal"
              type="outlined"
              label="Plus tard"
              class="flex justify-center w-full"
              @click="hideModal"
            />

            <AppButton
              v-else
              type="outlined"
              label="Annuler"
              class="flex justify-center w-full"
              @click="previewDocuments.uploadModal = false"
            />

            <LoadButton
              v-if="previewDocuments?.uploadModal"
              v-model="load"
              force-waiting
              class="button__default flex justify-center w-full"
              :disabled="!files.length"
              text-confirm="Ajouter"
              @click="uploadAndHide"
            >
            </LoadButton>
            <LoadButton
              v-else
              v-model="loadDocumentsLinks"
              force-waiting
              class="button__default flex justify-center w-full"
              :disabled="!createSession?.selectedDocuments?.length"
              text-confirm="Valider"
              @click="documentsLinks"
            >
            </LoadButton>
          </div>
        </footer>
      </div>
    </template>
  </CenterModal>
</template>
<style scoped lang="scss">
@use "assets/scss/texts";
.stable {
  scrollbar-gutter: stable;
}
.divider_header_footer {
  @apply body_med bottom-0 border-t-[2px] border-light-grey-color rounded-[4px] px-[64px] py-[16px] w-full bg-white;
}
.top_header_footer {
  @apply flex border-b-[2px] border-light-grey-color justify-between rounded-[4px];
}
</style>
